<template>
    <div>
        <div>
            <Title
                class="md:block md:mt-4 md:mb-4"
                text="請確認輸入的資料"
                style-code-page
            />
            <div class="min-h-[30vh]">
                <Data />
            </div>
        </div>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { ref } from 'vue';
import Title from '@/components/text/Title.vue';
import Loading from '@/components/Loading.vue';
import Data from './Data.vue';

export default {
    components: {
        Data,
        Title,
        Loading,
    },
    setup() {
        const isLoading = ref(false);
        return { isLoading };
    },
};
</script>
